module.exports = __webpack_public_path__ + "img/changying_lg.67d652cc.png";